import { render, staticRenderFns } from "./jason-vue-navigation.vue?vue&type=template&id=79b89f22&"
import script from "./jason-vue-navigation.vue?vue&type=script&lang=js&"
export * from "./jason-vue-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "jason-vue-navigation.vue"
export default component.exports